import { type AuthErrorType } from './types';

export class AuthError extends Error {
	public constructor(
		public readonly message: string,
		public readonly type?: AuthErrorType | undefined,
	) {
		super(message);
		this.name = 'AuthError';
		this.type = type;
		this.message = message;
	}
}
